import Vue from "vue";
import App from "./App.vue";
import { initMsal } from "./msalConfig";

await initMsal();
new Vue({
  render: h => h(App),
}).$mount("#app");
